import { getCatalogues } from "@/plugins/api.js"

export default {
  state: () => ({
    catalogues: []
  }),
  getters: {
    catalogues: (state) => {
      return state.catalogues
    }
  },
  mutations: {
    SET_CATALOGUES(state, catalogues) {
      state.catalogues = catalogues
    }
  }
}